<template>
    <MOPDialog
        v-model="dialogVisible"
        :modal="true"
        :header="''"
        :closable="false"
        :dismissableMask="false"
        :closeOnEscape="false"
        :style="{ width: '30vw' }"
        :breakpoints="{ '960px': '40vw', '641px': '60vw', '500px': '80vw' }"
    >
        <!-- <template #header>
            <div class="flex justify-end w-full">
                <i class="pi pi-times cursor-pointer" @click="handleClose" />
            </div>
        </template> -->
        <div class="flex flex-col items-center justify-center p-4">
            <img :src="image" class="success mb-4" :alt="content">
            <p class="text-lg text-gray-700 text-center">{{ content }}</p>
        </div>

        <template #footer>
            <MOPButton
                :label="'OK'"
                @click="handleClose"
                severity="primary"
            />
        </template>
    </MOPDialog>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
    visible: boolean
    content?: string
    image: string
}

interface Emits {
    (e: 'update:visible', value: boolean): void
    (e: 'ok'): void
}

const props = withDefaults(defineProps<Props>(), {
    content: 'Created Successfully'
})

const emit = defineEmits<Emits>()

const dialogVisible = computed({
    get: () => props.visible,
    set: (value: boolean) => {
        emit('update:visible', value)
    }
})

const handleClose = () => {
    dialogVisible.value = false
    emit('ok')
}
</script>

<style scoped>
.success {
    max-width: 100%;
    height: auto;
}

:deep(.p-dialog-header) {
    padding: 0.5rem !important;
}
</style>
